import gql from "graphql-tag";

// Query
export const GET_TRANSACTION = gql`
  query transaction($id: ID!) {
    transaction(id: $id) {
      id
      status
      date_created
      date_updated
      amount
      paid_amount
      payment_method
      fees
      boleto_url
      boleto_barcode
      boleto_expiration_date
      payables {
        fee
      }
    }
  }
`;
